module.exports = __webpack_public_path__ + "img/ko_kr.98a323db.png";